import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { ACTIVITY_SCROLLER_ID, COMMENT_HIGHLIGHT_CLASS } from "./const";

export function useScrollToComment(isLoaded: boolean) {
  const [searchParams, setSearchParams] = useSearchParams();
  const commentId = searchParams.get("commentId");

  useEffect(() => {
    if (commentId && isLoaded) {
      const scroller = document.getElementById(ACTIVITY_SCROLLER_ID);
      scroller?.scrollIntoView({ block: "center" });
      const element = document.getElementById(commentId);
      element?.scrollIntoView({ block: "center" });
      element?.classList.add(COMMENT_HIGHLIGHT_CLASS);

      setTimeout(() => {
        const element = commentId ? document.getElementById(commentId) : null;
        element?.classList.remove(COMMENT_HIGHLIGHT_CLASS);
        setSearchParams({ commentId: "" });
      }, 3 * 1000);
    }
  }, [commentId, isLoaded]);
}
